import { render, staticRenderFns } from "./StatementsSubmitted.vue?vue&type=template&id=d46d2216&scoped=true&"
import script from "./StatementsSubmitted.vue?vue&type=script&lang=js&"
export * from "./StatementsSubmitted.vue?vue&type=script&lang=js&"
import style0 from "./StatementsSubmitted.vue?vue&type=style&index=0&id=d46d2216&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d46d2216",
  null
  
)

export default component.exports